module.exports = __webpack_public_path__ + "img/EG.8134a674.png";